import ApontamentoPontosColetasUnicoReport from "entity/Indicador/reports/ApontamentoPontosColetasUnicoReport";
import apontamentoObservacaoReport from "entity/Indicador/reports/ApontamentoObservacaoReport";
import TableReportHelper from "report/helper";
import _ from "lodash";
import apontamentoImagesReport from "entity/Indicador/reports/ApontamentoImagesReport";
import { getTalhaoNomeDisplay, getTalhaoAreaDisplay } from "entity/Indicador/reports/talhaoDisplay";
export default async function falhasReport(indicador, visita) {
    const h = new TableReportHelper(visita.data);
    const IndicadorClass = indicador.constructor;
    const showOperador = indicador.type.field === "plantio";

    const apontamentos = visita.getApontamentosByIndicador(indicador);

    const content = [];
    if (apontamentos.length) {
        content.push([h.space()]);

        content.push([h.panel([h.row(h.title("RESUMO DE FALHAS", { fontSize: 10, alignment: "center" }))])]);
    }

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);

        const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

        const summaryTitles = [h.title("Talhão"), h.title("Área (ha)")];
        const summaryValues = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];
        const summaryWidths = [30, "*", 40, "*"];

        if (apontamento.variedade) {
            summaryTitles.push(h.title("Variedade"));
            summaryValues.push(h.textField("variedade.variedade"));
            summaryWidths.push(60, "*");
        }

        if (showOperador) {
            summaryTitles.push(h.title("Operador"));
            summaryValues.push(h.text(_.get(apontamento, "operador.operador", "")));
            summaryWidths.push(60, "*");
        }

        summaryTitles.push(h.title("Falhas (%)", { alignment: "right" }));
        summaryValues.push(
            h.number(apontamento.conformidade, { fillColor: h.conformidadeColors[status], alignment: "right" }),
        );
        summaryWidths.push(50, 50);

        content.push([h.panel([h.row(summaryTitles), h.row(summaryValues)], { widths: summaryWidths })]);
    }

    content.push([h.space()]);

    for (const apontamento of apontamentos) {
        const params = visita.cliente.getParams(IndicadorClass, apontamento.tipo, indicador.type);
        const pontosColetas = ApontamentoPontosColetasUnicoReport(
            visita,
            indicador,
            apontamento,
            params,
            "Valor (cm)",
            "valor",
        );

        content.push([
            apontamentoHeaderReportInt(visita, indicador, apontamento, params, "Falhas (%)", showOperador),

            pontosColetas,

            h.panel([h.row(h.title("Total de Falha no Talhão (%)"), h.textField("conformidade"))], {
                widths: [120, "*"],
            }),

            apontamentoImagesReport(visita, indicador, apontamento),
            apontamentoObservacaoReport(visita, indicador, apontamento),

            h.space(),
        ]);
    }
    return content;
}

function apontamentoHeaderReportInt(visita, indicador, apontamento, params, optLabelConformidade, showOperador) {
    const h = new TableReportHelper(apontamento);
    const IndicadorClass = indicador.constructor;

    const nomeAmostra = `${IndicadorClass.fullName} - ${IndicadorClass.abbrev}`;

    if (_.isEmpty(params)) {
        return h.panel(
            [
                // prettier-ignore
                h.row(
                    h.title("Amostra"),
                    h.text(nomeAmostra)
                ),

                h.row(
                    h.title(
                        "ATENÇÃO???????????????: Não existem parâmetros configurados no cliente para este indicador.",
                        {
                            colSpan: 2,
                        },
                    ),
                ),
            ],
            { widths: [60, "*"] },
        );
    }

    const status = IndicadorClass.getConformidadeStatus(apontamento.conformidade, params.meta);

    const firstRowValues = [
        h.title("Amostra"),
        h.text(nomeAmostra),
        h.title("Tipo"),
        h.textField("tipo"),
        h.title("Metros por Ponto"),
        h.text(params.metrosPorPonto),
        h.title("Meta (%)"),
        h.text(params.meta),
    ];
    const firstRowWidths = [40, "*", 30, 70, 80, 40, 45, 30];

    if (showOperador) {
        firstRowValues.push(h.title("Operador"));
        firstRowValues.push(h.textField("operador.operador"));
        firstRowWidths.push(55, "*");
    }

    const content = [
        h.panel([h.row(firstRowValues)], { widths: firstRowWidths }),

        (() => {
            const titleAr = [h.title("Talhão"), h.title("Área (ha)")];
            const valueAr = [h.text(getTalhaoNomeDisplay(apontamento)), h.text(getTalhaoAreaDisplay(apontamento))];
            const tamAr = ["*", "*"];

            if (apontamento.variedade) {
                titleAr.push(h.title("Variedade"));
                valueAr.push(h.textField("variedade.variedade"));
                tamAr.push("*");
            }

            titleAr.push(h.title(optLabelConformidade || "Conformidade (%)", { alignment: "right" }));
            valueAr.push(h.conformidadeField("conformidade", status, { alignment: "right" }));
            tamAr.push(90);

            return h.panel([h.row(titleAr), h.row(valueAr)], { widths: tamAr });
        })(),
    ];

    return h.unbreakable(content);
}
